import { Typography } from '@mui/material'
import { FlexCol } from '@xylabs/sdk-react'

const DataniumIcon = () => {
  return (
    <FlexCol width={32} height={32}>
      <Typography variant="subtitle2" style={{ opacity: 1 }}>
        0101
      </Typography>
      <Typography variant="subtitle2" style={{ opacity: 1 }}>
        1010
      </Typography>
    </FlexCol>
  )
}

export default DataniumIcon
